/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useLayoutEffect, useRef } from "react";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";

import {
  Table,
  Input,
  Button,
  Pagination,
  Select,
  Typography,
  Spin,
} from "antd";
import SearchInput from "./SearchInput";
import SmartSelect from "./SmartSelect";

// Utils
import { getAlert, getDataWithComp } from "../../../../utils/SamuiUtils";
import ProductModal from "../../../components/Modal/productmodal";
import { submitItems } from "../../../../utils/services";

// import DateRangePickerAntd from "../../../components/DateRangePickerAntd";
import dayjs from "dayjs";

const pick = (r, keys) => {
  for (const k of keys) {
    const v = r?.[k];
    if (v !== undefined && v !== null && String(v) !== "") return String(v);
  }
  return "";
};

const hashKey = (obj) => {
  const s = JSON.stringify(obj);
  let h = 5381;
  for (let i = 0; i < s.length; i++) h = (h * 33) ^ s.charCodeAt(i);
  return (h >>> 0).toString(36);
};

const makeStableKey = (r) => {
  if (r.Item_Id) return String(r.Item_Id);
  const idShape = {
    code: r.Item_Code ?? "",
    name: r.Item_Name ?? "",
    unit: r.Item_Unit_IN ?? "",
    size: r.Item_Size ?? "",
    colour: r.Item_Colour ?? "",
    series: r.Item_Series ?? "",
    brand: r.Item_Brand ?? "",
  };
  return `itm_${hashKey(idShape)}`;
};

const getSelVal = (v) =>
  v && typeof v === "object" ? (v.value ?? v.key ?? "") : (v ?? "");

const getSelLabel = (v) =>
  v && typeof v === "object" ? (v.label ?? v.value ?? "") : String(v ?? "");

const buildInitialData = (rows = [], whByItemId = {}) => {
  if (!rows.length) return null;
  const r0 = rows[0] || {};

  // console.debug(`[Main.js buildInitialData] Input rows: ${rows.length}`);
  const allWH = new Set(); // รวม WH ของทุก variant
  const details = rows.map((r, i) => {
    const iid = Number(r.Item_Id);
    const info = whByItemId[iid] || { whIds: new Set(), whNames: new Set() };
    info.whIds.forEach((id) => allWH.add(id));
    const statusYN = r.is_Active ?? r.Item_Status ?? r.StatusYN ?? "Y";
    return {
      key: r.Item_Code || r.Item_Barcode || String(r.Item_Id ?? i),
      Item_Id: r.Item_Id,
      Item_Barcode: r.Item_Barcode ?? "",
      Item_Code: r.Item_Code ?? "",
      Item_Name: r.Item_Name ?? "",
      Item_Short_Name: r.Item_Short_Name ?? r.Item_Shortname ?? "",
      Item_Code_Master: r.Item_Code_Master ?? "",
      Unit: r.Item_Unit_IN ?? r.Unit ?? "",
      Colour: r.Item_Colour ?? r.Colour ?? "",
      Size: r.Item_Size ?? r.Size ?? "",
      Brand: r.Item_Brand ?? r.Brand ?? "",
      Series: r.Item_Series ?? r.Series ?? "",
      Warehouses: Array.from(info.whNames).join(", "),
      InitQty: Number(r.Init_Qty ?? 0),
      Cost: Number(r.Item_Cost ?? r.Cost ?? 0),
      CreatedAt: r.CreatedAt ?? r.Created_At ?? "",
      CreatedBy: r.CreatedBy ?? r.Created_By ?? "",
      UpdatedAt: r.UpdatedAt ?? r.Updated_At ?? "",
      UpdatedBy: r.UpdatedBy ?? r.Updated_By ?? "",
      Price1: Number(r.Price1 ?? r.Item_Price ?? 0),
      Price2: Number(r.Price2 ?? r.Item_PriceA ?? 0),
      Price3: Number(r.Price3 ?? r.Item_PriceB ?? 0),
      StatusYN: statusYN,
      Status: statusYN === "Y" ? "Active" : "In-Active",
      WH_Ids: Array.from(info.whIds),
    };
  });

  const header = {
    Item_Group: r0.Item_Group ?? r0.Group_Id ?? "",
    Item_Short_Name: r0.Item_Short_Name ?? "",
    Item_Name: r0.Item_Name ?? "",
    Item_Name_EN: r0.Item_Name_EN ?? "",
    Item_Unit_IN: r0.Item_Unit_IN ?? r0.Unit ?? "",
    Item_Brand: r0.Item_Brand ?? "",
    Item_Series: r0.Item_Series ?? "",
    Item_Cost: Number(r0.Item_Cost ?? r0.Cost ?? 0),
    Item_Price: Number(r0.Item_Price ?? r0.Price1 ?? 0),
    Item_PriceA: Number(r0.Item_PriceA ?? r0.Price2 ?? 0),
    Item_PriceB: Number(r0.Item_PriceB ?? r0.Price3 ?? 0),
    Item_Status:
      r0.is_Active ?? r0.Is_Active ?? r0.Item_Status ?? r0.StatusYN ?? "Y",
    Item_Short_Name2: r0.Item_Short_Name ?? "",
    WH_Ids: Array.from(allWH),
    Init_Qty_All: Number(r0.Init_Qty ?? 0),
  };

  const filledDetails = details.map((d) => ({
    ...d,
    WH_Ids:
      Array.isArray(d.WH_Ids) && d.WH_Ids.length ? d.WH_Ids : header.WH_Ids,
  }));

  return { header, details: filledDetails };
};

function Main({ masterList, detailList, name }) {
  const [dataMasterList, setDataMasterList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [kwDraft, setKwDraft] = useState("");
  const [kw, setKw] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRowKey, setSelectedRowKey] = useState(null);

  // ✅ เพิ่ม state สำหรับเก็บข้อมูลเต็มๆ สำหรับสร้าง filter options
  const [filterMasterData, setFilterMasterData] = useState([]);

  const searchRef = React.useRef(null);
  const dataMasterListRef = useRef([]);
  const lastFocusKeyRef = useRef(null);

  const scrollPositionRef = React.useRef({ scrollTop: 0, scrollLeft: 0 });
  const shouldRestoreScrollRef = React.useRef(false);

  const [pendingFilters, setPendingFilters] = useState({
    createdRange: { start: null, end: null },
    group: undefined,
    brand: undefined,
    size: undefined,
    series: undefined,
    colour: undefined,
    status: undefined,
    _kw: "",
  });

  const [modalState, setModalState] = useState({
    open: false,
    mode: "create",
    data: null,
    focusKey: null,
  });

  const [filters, setFilters] = useState(pendingFilters);
  // ===== helpers =====

  const tableWrapRef = useRef(null);
  const footerRef = useRef(null);
  const [scrollY, setScrollY] = useState(480);
  const totalItems = dataMasterList.length;
  const startIdx = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endIdx = Math.min(currentPage * itemsPerPage, totalItems);
  const displayItems = dataMasterList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const recomputeScrollY = () => {
    const wrap = tableWrapRef.current;
    if (!wrap) return;
    const rect = wrap.getBoundingClientRect();
    const viewportH =
      window.innerHeight || document.documentElement.clientHeight;
    const bottomGap = 16;
    const available = Math.max(200, viewportH - rect.top - bottomGap);
    const footerH = footerRef.current?.offsetHeight ?? 0;
    const thead =
      wrap.querySelector(".ant-table-header") ||
      wrap.querySelector(".ant-table-thead");

    const theadH = thead?.offsetHeight ?? 48;
    setScrollY(Math.max(160, available - footerH - theadH));
  };

  const onRowSelected = React.useCallback(async (item, currentList = []) => {
    try {
      const tableBody = tableWrapRef.current?.querySelector(".ant-table-body");
      if (tableBody) {
        scrollPositionRef.current = {
          scrollTop: tableBody.scrollTop,
          scrollLeft: tableBody.scrollLeft,
        };
        shouldRestoreScrollRef.current = true;
      }

      const rowKey = item._key || makeStableKey(item);
      setSelectedRowKey(rowKey);
      lastFocusKeyRef.current = String(
        item?.Item_Code ?? item?.Item_Barcode ?? item?.Item_Id ?? rowKey,
      );

      const targetShortName = pick(item, ["Item_Short_Name"]) || "";
      const targetBrand = pick(item, ["Item_Brand"]) || "";
      const targetSeries = pick(item, ["Item_Series"]) || "";
      const targetColour = pick(item, ["Item_Colour"]) || "";

      if (!targetShortName) {
        getAlert("FAILED", "ไม่พบชื่อสินค้าหลัก");
        return;
      }

      // ✅ ใช้ ref แทน state
      const list = (dataMasterListRef.current || []).filter((r) => {
        const rShortName = pick(r, ["Item_Short_Name"]) || "";
        const rBrand = pick(r, ["Item_Brand"]) || "";
        const rSeries = pick(r, ["Item_Series"]) || "";
        const rColour = pick(r, ["Item_Colour"]) || "";

        return (
          rShortName === targetShortName &&
          rBrand === targetBrand &&
          rSeries === targetSeries &&
          rColour === targetColour
        );
      });

      if (!list.length) {
        getAlert("FAILED", "ไม่พบรายการของสินค้าเพื่อแก้ไข");
        return;
      }

      const sortedList = list.sort((a, b) => {
        const rankSizeA = Number(a.Size_Line ?? Number.MAX_SAFE_INTEGER);
        const rankSizeB = Number(b.Size_Line ?? Number.MAX_SAFE_INTEGER);

        if (rankSizeA !== rankSizeB) return rankSizeA - rankSizeB;

        const sizeA = pick(a, ["Item_Size"]) || "";
        const sizeB = pick(b, ["Item_Size"]) || "";
        return sizeA.localeCompare(sizeB, "th");
      });

      const ids = sortedList
        .map((r) => Number(r.Item_Id))
        .filter(Number.isFinite);

      if (!ids.length) {
        getAlert("FAILED", "ไม่พบ Item_Id ของสินค้า");
        return;
      }

      const stcRows = await getDataWithComp(
        "WH_ITEM_STC",
        `AND Item_Id IN (${ids.join(",")})`,
      );

      const stcs = Array.isArray(stcRows) ? stcRows : [];
      const whByItemId = {};
      for (const s of stcs) {
        const iid = Number(s.Item_Id);
        const wid = Number(s.WH_Id);
        if (!Number.isFinite(iid) || !Number.isFinite(wid)) continue;

        if (!whByItemId[iid]) {
          whByItemId[iid] = { whIds: new Set(), whNames: new Set() };
        }
        whByItemId[iid].whIds.add(wid);
      }

      const allWHIds = Array.from(
        new Set(Object.values(whByItemId).flatMap((v) => Array.from(v.whIds))),
      );
      let whNameMap = {};
      if (allWHIds.length) {
        const whMst = await getDataWithComp(
          "Tb_Set_WH",
          `AND WH_Id IN (${allWHIds.join(",")}) AND WH_Status='Y'`,
        );
        (Array.isArray(whMst) ? whMst : []).forEach((w) => {
          whNameMap[Number(w.WH_Id)] = w.WH_Name ?? String(w.WH_Id);
        });
      }

      for (const iid of Object.keys(whByItemId)) {
        const info = whByItemId[iid];
        for (const wid of info.whIds) {
          info.whNames.add(whNameMap[wid] ?? String(wid));
        }
      }

      const initialData = buildInitialData(sortedList, whByItemId);
      const focusKey = String(
        item?.Item_Code ?? item?.Item_Barcode ?? item?.Item_Id ?? "",
      );

      setModalState({
        open: true,
        mode: "edit",
        data: focusKey ? { ...initialData, __focusKey: focusKey } : initialData,
        focusKey: focusKey,
      });
    } catch (e) {
      console.error(e);
      getAlert("FAILED", "โหลดข้อมูลสินค้าไม่สำเร็จ");
    }
  }, []);

  const onPageInsert = React.useCallback(() => {
    setModalState({
      open: true,
      mode: "create",
      data: null,
      focusKey: null,
    });
  }, []);

  const { Text } = Typography;

  const [loading, setLoading] = useState(false);
  const lastReqIdRef = useRef(0);
  const norm = (v) =>
    String(v ?? "")
      .trim()
      .replace(/\s+/g, " ")
      .toUpperCase();
  const applyFilters = React.useCallback(
    async (kwFromUI = "") => {
      const curKw = String(kwFromUI ?? "");
      setKw(curKw);

      const nextFilters = { ...pendingFilters, _kw: curKw };
      setFilters(nextFilters);
      setLoading(true);

      try {
        const where = buildWhereFromFilters(nextFilters);
        const reqId = ++lastReqIdRef.current;
        const orderBy =
          " ORDER BY Item_Short_Name, Item_Brand, Item_Series, Item_Colour, Size_Line";
        const rows = await getDataWithComp("View_Set_Item", where + orderBy);

        if (reqId !== lastReqIdRef.current) return;

        const list = Array.isArray(rows) ? rows : [];
        const mappedList = list.map((r) => ({
          ...r,
          _key: makeStableKey(r),
        }));
        setDataMasterList(mappedList);
        return mappedList;
      } catch (e) {
        console.error(e);
        getAlert("FAILED", "ดึงข้อมูลไม่สำเร็จ");
        return [];
      } finally {
        setLoading(false);
      }
    },
    [pendingFilters],
  );

  const refreshAndRestoreFocus = React.useCallback(
    async (focusKey) => {
      const rows = await applyFilters(kw);
      const targetKey = String(
        focusKey ?? lastFocusKeyRef.current ?? selectedRowKey ?? "",
      ).trim();

      if (!targetKey) return;

      const foundIndex = (rows || []).findIndex((r) => {
        const candidateKeys = [
          r.Item_Code,
          r.Item_Barcode,
          r.Item_Id,
          r._key,
        ].map((v) => String(v ?? "").trim());
        return candidateKeys.includes(targetKey);
      });

      if (foundIndex >= 0) {
        const row = rows[foundIndex];
        setSelectedRowKey(row._key || makeStableKey(row));
        setCurrentPage(Math.floor(foundIndex / itemsPerPage) + 1);
      } else {
        setSelectedRowKey(null);
      }
    },
    [applyFilters, itemsPerPage, kw, selectedRowKey],
  );

  const chexkLoading = () => {
    setIsLoading(false);
  };

  // --- ใช้ใน initialize() ---
  const initialize = () => {
    try {
      if (Array.isArray(masterList) && masterList.length > 0) {
        // reset กันข้อมูลค้าง
        setDataMasterList([]);
        // map ใส่คีย์ที่คงที่/ไม่ซ้ำ
        const withKey = masterList.map((r) => ({
          ...r,
          _key: makeStableKey(r),
        }));
        setDataMasterList(withKey);
      } else {
        setDataMasterList([]);
      }
      chexkLoading();
    } catch (e) {
      getAlert("FAILED", e.message);
    }
  };

  const cmpStrBy = (keys) => (a, b) =>
    pick(a, keys).localeCompare(pick(b, keys), "th");
  const cmpNumBy = (keys) => (a, b) =>
    (parseFloat(pick(a, keys)) || 0) - (parseFloat(pick(b, keys)) || 0);
  const cmpDateBy = (keys) => (a, b) => {
    const da = dayjs(pick(a, keys) || 0);
    const db = dayjs(pick(b, keys) || 0);
    return da.valueOf() - db.valueOf();
  };

  const fmt = (v) => Number(v || 0).toLocaleString();

  const CopyCell = ({ text }) => (
    <Text
      copyable={{ text, tooltips: ["คัดลอก", "คัดลอกแล้ว"] }}
      ellipsis={{ tooltip: text }}
      style={{ display: "inline-block", maxWidth: "100%" }}
    >
      {text}
    </Text>
  );

  const takeRaw = (r, keys) => {
    for (const k of keys) {
      const v = r?.[k];
      if (v !== undefined && v !== null && String(v).trim() !== "") {
        const raw = String(v).trim();
        return { raw, n: norm(raw) };
      }
    }
    return { raw: "", n: "" };
  };

  const uniqueOptions = (rows, keys) => {
    const map = new Map();
    for (const r of rows) {
      const { raw, n } = takeRaw(r, Array.isArray(keys) ? keys : [keys]);
      if (!n) continue;
      if (!map.has(n)) map.set(n, raw);
    }
    const arr = Array.from(map.values()).map((label) => ({
      value: label,
      label,
    }));
    arr.sort((a, b) => a.label.localeCompare(b.label, "th"));
    return arr;
  };

  const fmtDate = (v) => {
    if (!v) return "-";
    const d = new Date(v);

    const pad = (n) => String(n).padStart(2, "0");

    return (
      pad(d.getUTCDate()) +
      "/" +
      pad(d.getUTCMonth() + 1) +
      "/" +
      d.getUTCFullYear() +
      " " +
      pad(d.getUTCHours()) +
      ":" +
      pad(d.getUTCMinutes())
    );
  };

  const widthcolumns = {
    rowno: 70,
    group: 130,
    code: 180,
    name: 450,
    status: 100,
    colour: 90,
    unit: 60,
    brand: 120,
    series: 120,
    size: 100,
    price1: 110,
    price2: 110,
    price3: 110,
    created_date: 160,
    created_by: 140,
    update_date: 160,
    update_by: 140,
    edit: 80,
  };
  const w = (k) => widthcolumns[k];

  const columns = (currentPage, itemsPerPage, onRowSelected) => [
    // ===== fixed left =====
    {
      title: "ลำดับ",
      key: "rowno",
      width: w("rowno"),
      align: "center",
      fixed: "left",
      sorter: (a, b) => 0,
      render: (_v, r, idx) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return idx + 1 + (currentPage - 1) * itemsPerPage;
      },
    },
    {
      title: "หมวดหมู่สินค้า",
      key: "group",
      dataIndex: "Item_Group_Name",
      width: w("group"),
      fixed: "left",
      render: (_, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return <CopyCell text={displayGroupName(r)} />;
      },
      sorter: (a, b) =>
        displayGroupName(a).localeCompare(displayGroupName(b), "th"),
    },
    {
      title: "รหัสสินค้า",
      dataIndex: "Item_Code",
      key: "Item_Code",
      width: w("code"),
      // align: "center",
      fixed: "left",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return (
          <CopyCell text={String(v ?? "")} style={{ textAlign: "left" }} />
        );
      },
      sorter: cmpStrBy(["Item_Code"]),
    },
    {
      title: "ชื่อสินค้า",
      dataIndex: "Item_Name",
      key: "Item_Name",
      width: w("name"),
      align: "left",
      fixed: "left",
      render: (v, record) => {
        if (record._isEmpty) {
          return {
            children: (
              <div
                style={{
                  padding: "40px 0",
                  color: "#999",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    marginBottom: "8px",
                    fontWeight: 500,
                  }}
                >
                  ไม่พบข้อมูล
                </div>
                <div style={{ fontSize: "14px" }}>
                  กรุณาลองค้นหาด้วยเงื่อนไขอื่น
                </div>
              </div>
            ),
            props: { colSpan: 17 },
          };
        }

        return (
          <a
            href="#"
            className="item-name-link"
            onClick={(e) => {
              // e.preventDefault();
              // e.stopPropagation();
              onRowSelected?.(record, displayItems);
            }}
          >
            {String(v ?? "")}
          </a>
        );
      },
      sorter: cmpStrBy(["Item_Name"]),
    },
    {
      title: "ใช้งาน",
      dataIndex: "Item_Status",
      key: "Item_Status",
      width: w("status"),
      align: "center",
      render: (_v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        const statusYN =
          r.is_Active ?? r.Is_Active ?? r.Item_Status ?? r.StatusYN ?? "Y";
        return statusYN === "Y" ? "ใช้งาน" : "ไม่ใช้งาน";
      },
      sorter: (a, b) => {
        const statusA =
          a.is_Active ?? a.Is_Active ?? a.Item_Status ?? a.StatusYN ?? "Y";
        const statusB =
          b.is_Active ?? b.Is_Active ?? b.Item_Status ?? b.StatusYN ?? "Y";
        return String(statusA).localeCompare(String(statusB), "th");
      },
    },

    // ===== middle (scrollable) =====
    {
      title: "หน่วย",
      dataIndex: "Item_Unit_IN",
      key: "Item_Unit_IN",
      width: w("unit"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return v;
      },
      sorter: cmpStrBy(["Item_Unit_IN"]),
    },
    {
      title: "สี",
      dataIndex: "Item_Colour",
      key: "Item_Colour",
      width: w("colour"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return r.Colour_Name || r.Item_Colour || v || "-";
      },
      sorter: cmpStrBy(["Item_Colour"]),
    },
    {
      title: "ขนาด",
      dataIndex: "Item_Size",
      key: "Item_Size",
      width: w("size"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return v;
      },
      sorter: (a, b) => {
        // ใช้ Size_Line จาก View
        const rankA = Number(a.Size_Line ?? Number.MAX_SAFE_INTEGER);
        const rankB = Number(b.Size_Line ?? Number.MAX_SAFE_INTEGER);
        if (rankA !== rankB) return rankA - rankB;

        const sizeA = pick(a, ["Item_Size"]) || "";
        const sizeB = pick(b, ["Item_Size"]) || "";
        return sizeA.localeCompare(sizeB, "th");
      },
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "ยี่ห้อ",
      dataIndex: "Item_Brand",
      key: "Item_Brand",
      width: w("brand"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return v;
      },
      sorter: cmpStrBy(["Item_Brand"]),
    },
    {
      title: "รุ่น",
      dataIndex: "Item_Series",
      key: "Item_Series",
      width: w("series"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return v;
      },
      sorter: cmpStrBy(["Item_Series"]),
    },

    // ===== fixed right =====
    {
      title: "ราคาสินค้า1",
      dataIndex: "Item_Price",
      key: "Item_Price",
      width: w("price1"),
      align: "right",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return fmt(v);
      },
      sorter: cmpNumBy(["Item_Price"]),
    },
    {
      title: "ราคาสินค้า2",
      dataIndex: "Item_PriceA",
      key: "Item_PriceA",
      width: w("price2"),
      align: "right",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return fmt(v);
      },
      sorter: cmpNumBy(["Item_PriceA"]),
    },
    {
      title: "ราคาสินค้า3",
      dataIndex: "Item_PriceB",
      key: "Item_PriceB",
      width: w("price3"),
      align: "right",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return fmt(v);
      },
      sorter: cmpNumBy(["Item_PriceB"]),
    },
    {
      title: "วันที่สร้าง",
      dataIndex: "Created_Date",
      key: "Created_Date",
      width: w("created_date"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return fmtDate(v || r.CreatedAt || r.Created_At);
      },
      sorter: cmpDateBy(["Created_Date", "CreatedAt", "Created_At"]),
    },
    {
      title: "สร้างโดย",
      dataIndex: "Created_By_Name",
      key: "Created_By_Name",
      width: w("created_by"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return v || r.CreatedBy || r.Created_By || "-";
      },
      sorter: cmpStrBy(["Created_By_Name", "CreatedBy", "Created_By"]),
    },
    {
      title: "วันที่แก้ไข",
      dataIndex: "Update_Date",
      key: "Update_Date",
      width: w("update_date"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return fmtDate(v || r.UpdatedAt || r.Updated_At);
      },
      sorter: cmpDateBy(["Update_Date", "UpdatedAt", "Updated_At"]),
    },
    {
      title: "ผู้แก้ไข",
      dataIndex: "Update_By_Name",
      key: "Update_By_Name",
      width: w("update_by"),
      align: "center",
      render: (v, r) => {
        if (r._isEmpty) return { props: { colSpan: 0 } };
        return v || r.UpdatedBy || r.Updated_By || "-";
      },
      sorter: cmpStrBy(["Update_By_Name", "UpdatedBy", "Updated_By"]),
    },
    {
      title: "แก้ไข",
      key: "edit",
      width: w("edit"),
      align: "center",
      fixed: "right",
      sorter: (a, b) => 0,
      render: (_, record) => {
        if (record._isEmpty) return { props: { colSpan: 0 } };
        return (
          <i
            className="fas fa-edit fw-bold"
            style={{ color: "#EF6C00", cursor: "pointer" }}
            title="แก้ไข"
            onClick={(e) => {
              e.stopPropagation();
              onRowSelected?.(record, displayItems);
            }}
          />
        );
      },
    },
  ];

  const displayGroupName = (r) => {
    return r.Group_Name || "-";
  };

  const options = React.useMemo(() => {
    // ✅ ใช้ filterMasterData ที่โหลดข้อมูลเต็มโดยไม่มี filter
    const rows =
      filterMasterData.length > 0 ? filterMasterData : masterList || [];
    const groupSet = new Set();
    const groupOpts = [];
    for (const r of rows) {
      const id = String(r.Item_Group ?? "").trim();
      const name = String(r.Group_Name ?? "").trim();
      if (id && name && !groupSet.has(id)) {
        groupSet.add(id);
        groupOpts.push({ value: id, label: name });
      }
    }
    groupOpts.sort((a, b) => a.label.localeCompare(b.label, "th"));

    const brands = uniqueOptions(rows, ["Item_Brand"]);
    const series = uniqueOptions(rows, ["Item_Series"]);
    const colours = uniqueOptions(rows, ["Item_Colour"]);

    const sizeMap = new Map();
    for (const r of rows) {
      const sizeName = String(r.Size_Name ?? "").trim();
      const sizeLine = Number(r.Size_Line ?? 999);
      if (sizeName && !sizeMap.has(sizeName)) {
        sizeMap.set(sizeName, sizeLine);
      }
    }
    const sizes = Array.from(sizeMap.entries())
      .map(([name, line]) => ({ value: name, label: name, line }))
      .sort((a, b) => a.line - b.line);

    return {
      groups: groupOpts,
      brands,
      sizes,
      series,
      colours,
      statuses: [
        { value: "Y", label: "พร้อมขาย" },
        { value: "N", label: "ไม่พร้อมขาย" },
      ],
    };
  }, [filterMasterData, masterList]);

  const handleRowClick = React.useCallback((record) => {
    const tableBody = tableWrapRef.current?.querySelector(".ant-table-body");
    if (tableBody) {
      scrollPositionRef.current = {
        scrollTop: tableBody.scrollTop,
        scrollLeft: tableBody.scrollLeft,
      };
      shouldRestoreScrollRef.current = true;
    }

    setSelectedRowKey(record._key || makeStableKey(record));
  }, []);

  const tableColumns = React.useMemo(
    () => columns(currentPage, itemsPerPage, onRowSelected),
    [currentPage, itemsPerPage, onRowSelected],
  );

  const esc = (s = "") => String(s).replaceAll("'", "''");
  const like = (s = "") => `%${esc(String(s).trim())}%`;

  const buildWhereFromFilters = React.useCallback(
    (f) => {
      const { createdRange, group, brand, size, series, colour, status, _kw } =
        f || {};
      const parts = [];

      if (_kw && String(_kw).trim() !== "") {
        const kw = like(_kw);
        parts.push(
          `AND (Item_Code LIKE '${kw}' OR Item_Name LIKE '${kw}' OR Item_Barcode LIKE '${kw}'
       OR Item_Colour LIKE '${kw}' OR Item_Series LIKE '${kw}' OR Item_Brand LIKE '${kw}')`,
        );
      }

      if (group) {
        const raw = String(getSelVal(group) ?? "").trim();
        const gidNum = Number(raw);
        if (Number.isFinite(gidNum)) {
          parts.push(`AND Item_Group=${gidNum}`);
        }
      }

      if (brand)
        parts.push(
          `AND Item_Brand='${esc(getSelVal(brand) || getSelLabel(brand))}'`,
        );
      if (size)
        parts.push(
          `AND Item_Size='${esc(getSelVal(size) || getSelLabel(size))}'`,
        );
      if (series)
        parts.push(
          `AND Item_Series='${esc(getSelVal(series) || getSelLabel(series))}'`,
        );
      if (colour)
        parts.push(
          `AND Item_Colour='${esc(getSelVal(colour) || getSelLabel(colour))}'`,
        );
      if (status) {
        const statusValue = getSelVal(status) || getSelLabel(status);
        // แปลงค่าจากภาษาไทยเป็น Y/N
        const dbStatus =
          statusValue === "พร้อมขาย"
            ? "Y"
            : statusValue === "ไม่พร้อมขาย"
              ? "N"
              : statusValue;
        parts.push(`AND ISNULL(is_Active, Item_Status)='${esc(dbStatus)}'`);
      }

      if (createdRange?.start || createdRange?.end) {
        const s = createdRange?.start
          ? dayjs(createdRange.start)
              .startOf("day")
              .format("YYYY-MM-DD HH:mm:ss")
          : null;
        const e = createdRange?.end
          ? dayjs(createdRange.end).endOf("day").format("YYYY-MM-DD HH:mm:ss")
          : null;
        if (s) parts.push(`AND (CreatedAt >= '${s}' OR Created_At >= '${s}')`);
        if (e) parts.push(`AND (CreatedAt <= '${e}' OR Created_At <= '${e}')`);
      }

      return parts.join(" ");
    },
    [getSelVal, getSelLabel],
  );
  const ItemsTable = React.memo(
    function ItemsTable({
      loading,
      columns,
      data,
      scrollY,
      selectedRowKey,
      onRowClick,
    }) {
      const tableData =
        data.length === 0 ? [{ _key: "empty-row", _isEmpty: true }] : data;

      return (
        <Table
          loading={loading}
          size="small"
          rowKey="_key"
          columns={columns}
          rowClassName={(record) => {
            if (record._isEmpty) return "";
            if (record._key === selectedRowKey) return "ant-table-row-selected";
            return "";
          }}
          onRow={(record) => ({
            style: record._isEmpty ? { pointerEvents: "none" } : undefined,
            onClick: () => {
              if (!record._isEmpty && onRowClick) {
                onRowClick(record);
              }
            },
          })}
          dataSource={tableData}
          bordered
          sticky
          scroll={{ x: "max-content", y: scrollY }}
          pagination={false}
          locale={{
            emptyText: (
              <div style={{ padding: "40px 0", color: "#999" }}>
                <div style={{ fontSize: "16px", marginBottom: "8px" }}>
                  ไม่พบข้อมูล
                </div>
                <div style={{ fontSize: "14px" }}>
                  กรุณาลองค้นหาด้วยเงื่อนไขอื่น
                </div>
              </div>
            ),
          }}
        />
      );
    },

    (prevProps, nextProps) => {
      return (
        prevProps.loading === nextProps.loading &&
        prevProps.scrollY === nextProps.scrollY &&
        prevProps.selectedRowKey === nextProps.selectedRowKey &&
        prevProps.data.length === nextProps.data.length &&
        prevProps.columns === nextProps.columns &&
        prevProps.onRowClick === nextProps.onRowClick
      );
    },
  );

  useEffect(() => {
    dataMasterListRef.current = dataMasterList;
  }, [dataMasterList]);

  // ✅ โหลดข้อมูลเต็มสำหรับ filter options (ไม่กรอง)
  useEffect(() => {
    const loadFilterMasterData = async () => {
      try {
        // โหลดข้อมูลทั้งหมด ไม่ใส่ filter (เฉพาะสถานะ Active)
        const rows = await getDataWithComp("View_Set_Item", "");
        const list = Array.isArray(rows) ? rows : [];
        setFilterMasterData(list);
      } catch (e) {
        console.error("Failed to load filter master data:", e);
        // ถ้าโหลดไม่สำเร็จ ใช้ masterList จาก props
        setFilterMasterData(masterList || []);
      }
    };

    loadFilterMasterData();
  }, []); // เรียกครั้งเดียวตอน mount

  useEffect(() => {
    const ro = new ResizeObserver(() => recomputeScrollY());
    if (tableWrapRef.current) ro.observe(tableWrapRef.current);
    window.addEventListener("resize", recomputeScrollY);
    recomputeScrollY(); // ครั้งแรก
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", recomputeScrollY);
    };
  }, []);

  useEffect(() => {
    recomputeScrollY();
  }, [dataMasterList.length, itemsPerPage, currentPage]);

  useEffect(() => {
    const pages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
    if (currentPage > pages) setCurrentPage(pages);
  }, [totalItems, itemsPerPage]);

  useEffect(() => {
    if (!loading && !isLoading && shouldRestoreScrollRef.current) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const tableBody =
            tableWrapRef.current?.querySelector(".ant-table-body");
          if (tableBody && scrollPositionRef.current) {
            tableBody.scrollTop = scrollPositionRef.current.scrollTop;
            tableBody.scrollLeft = scrollPositionRef.current.scrollLeft;
            shouldRestoreScrollRef.current = false;
          }
        });
      });
    }
  }, [loading, isLoading, dataMasterList]);

  const didInit = useRef(false);

  useEffect(() => {
    initialize();
    if (!didInit.current) {
      didInit.current = true;
      applyFilters(kw);
    }
  }, [masterList, detailList]);

  return (
    <>
      <Spin spinning={loading || isLoading} fullscreen />

      <>
        <div className="page-header d-flex justify-content-between align-items-center mb-0">
          <Breadcrumbs
            page={name}
            items={[
              { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
              { name: name, url: "/tbsetitem" },
            ]}
          />
        </div>
        <div
          className="p-3 rounded-3 my-2 shadow-lg"
          style={{ backgroundColor: "#ffff" }}
        >
          <div className="row g-2 align-items-end">
            {/* ค้นหา */}
            <div className="col-12 col-xl-2" style={{ width: 200 }}>
              <span className="d-block fw-semibold small mb-1">ค้นหา</span>
              <SearchInput
                ref={searchRef}
                value={kwDraft}
                // onChange={onKwDraftChange}
                onSearchNow={(v) => {
                  setKwDraft(v);
                  setKw(v);
                  applyFilters(v);
                }}
                setSelectedRowKey={setSelectedRowKey}
                placeholder="ค้นหาข้อมูล"
              />
            </div>

            {/* หมวดหมู่ */}
            <div className="col-3 col-xl-2" style={{ width: 180 }}>
              <span className="d-block fw-semibold small mb-1">
                หมวดหมู่สินค้า
              </span>
              <SmartSelect
                className="w-100"
                allowClear
                placeholder="ทั้งหมด"
                value={pendingFilters.group}
                onChange={(v) => setPendingFilters((s) => ({ ...s, group: v }))}
                options={options.groups}
                maxRender={120}
                debounceMs={180}
                returnObject
              />
            </div>

            {/* ยี่ห้อ */}
            <div className="col-3 col-xl-2" style={{ width: 100 }}>
              <span className="d-block fw-semibold small mb-1">ยี่ห้อ</span>
              <SmartSelect
                className="w-100"
                allowClear
                placeholder="ทั้งหมด"
                value={pendingFilters.brand}
                onChange={(v) => setPendingFilters((s) => ({ ...s, brand: v }))}
                options={options.brands}
              />
            </div>

            {/* ขนาด */}
            <div className="col-3 col-xl-1" style={{ width: 100 }}>
              <span className="d-block fw-semibold small mb-1">ขนาด</span>
              <SmartSelect
                className="w-100"
                allowClear
                placeholder="ทั้งหมด"
                value={pendingFilters.size}
                onChange={(v) => setPendingFilters((s) => ({ ...s, size: v }))}
                options={options.sizes}
              />
            </div>

            {/* รุ่น */}
            <div className="col-3 col-xl-1" style={{ width: 160 }}>
              <span className="d-block fw-semibold small mb-1">รุ่น</span>
              <SmartSelect
                className="w-100"
                allowClear
                placeholder="ทั้งหมด"
                value={pendingFilters.series}
                onChange={(v) =>
                  setPendingFilters((s) => ({ ...s, series: v }))
                }
                options={options.series}
              />
            </div>

            {/* สี */}
            <div className="col-3 col-xl-1" style={{ width: 160 }}>
              <span className="d-block fw-semibold small mb-1">สี</span>
              <SmartSelect
                className="w-100"
                allowClear
                placeholder="ทั้งหมด"
                value={pendingFilters.colour}
                onChange={(v) =>
                  setPendingFilters((s) => ({ ...s, colour: v }))
                }
                options={options.colours}
              />
            </div>

            {/* สถานะสินค้า */}
            <div className="col-3 col-xl-1" style={{ width: 160 }}>
              <span className="d-block fw-semibold small mb-1">สถานะ</span>
              <Select
                className="w-100"
                allowClear
                placeholder="ทั้งหมด"
                value={pendingFilters.status}
                onChange={(v) =>
                  setPendingFilters((s) => ({ ...s, status: v }))
                }
                options={options.statuses}
              />
            </div>
            <div className="col-3 col-xl-1" style={{ width: 100 }}>
              <Button
                type="primary"
                onClick={() => {
                  const v = searchRef.current?.getValue?.() ?? kwDraft;
                  setSelectedRowKey(null); // ✅ รีเซ็ตการไฮไลท์เมื่อค้นหาใหม่
                  applyFilters(v);
                }}
                loading={loading}
              >
                ค้นหา
              </Button>
            </div>

            {/* ปุ่มสร้าง */}
            <div className="col-12 col-xl d-flex justify-content-xl-end">
              <div></div>

              <Button
                type="primary"
                onClick={onPageInsert}
                className="btn btn-warning text-white ms-xl-2 mt-2 mt-xl-0"
                style={{ backgroundColor: "#EF6C00", borderColor: "#EF6C00" }}
                icon={<i className="fa fa-plus" />}
              >
                สร้าง{name}
              </Button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card p-2">
              <div ref={tableWrapRef} style={{ position: "relative" }}>
                <ItemsTable
                  loading={loading || isLoading}
                  columns={tableColumns}
                  data={displayItems}
                  scrollY={scrollY}
                  selectedRowKey={selectedRowKey}
                  onRowClick={handleRowClick}
                />
              </div>
            </div>

            <div
              ref={footerRef}
              className="d-flex justify-content-between align-items-center mt-2"
            >
              <div className="d-flex align-items-center gap-2">
                <span>
                  {startIdx}-{endIdx} จาก {totalItems} รายการ
                </span>
                <span className="mx-2">|</span>
                <div className="d-flex align-items-center gap-1">
                  <Select
                    size="small"
                    value={itemsPerPage}
                    style={{ width: 100 }}
                    onChange={(val) => {
                      const pageSize =
                        val === -1 ? totalItems || 1 : Number(val);
                      setItemsPerPage(pageSize);
                      setCurrentPage(1);
                    }}
                    options={[
                      { value: 50, label: "50 / page" },
                      { value: 100, label: "100 / page" },
                      { value: 150, label: "150 / page" },
                      { value: -1, label: "All / page" },
                    ]}
                  />
                </div>
              </div>
              <Pagination
                size="small"
                current={currentPage}
                pageSize={itemsPerPage}
                total={totalItems}
                showSizeChanger={false}
                onChange={(page) => setCurrentPage(page)}
              />
            </div>
          </div>
        </div>
        {/* ==== Product Edit Modal ==== */}
        <ProductModal
          open={modalState.open}
          setOpen={(isOpen) =>
            setModalState((prev) => ({ ...prev, open: isOpen }))
          }
          mode={modalState.mode}
          initialData={modalState.data}
          onClose={() => {
            setModalState({
              open: false,
              mode: "create",
              data: null,
              focusKey: null,
            });
          }}
          onDataChanged={async () => {
            await refreshAndRestoreFocus(modalState.focusKey);
          }}
          onSubmit={async (payload) => {
            try {
              setIsLoading(true);

              const res = await submitItems(payload);

              if (res?.ok) {
                getAlert("OK", "บันทึกสำเร็จ");
                setModalState({
                  open: false,
                  mode: "create",
                  data: null,
                  focusKey: null,
                });
                await refreshAndRestoreFocus(payload?.header?.itemBaseCode);
              } else {
                console.debug("submitItems failed:", res);
              }
            } catch (e) {
              console.error(e);
              getAlert("FAILED", "บันทึกไม่สำเร็จ");
            } finally {
              setIsLoading(false);
            }
          }}
        />
        <style jsx global>{`
          .pm-overlay {
            position: fixed !important;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 1000;
            overflow-y: auto;
          }

          .ant-table-body {
            scroll-behavior: auto !important; /* ปิด smooth scroll */
          }

          .card {
            contain: layout style; /* CSS containment */
          }
          .items-table .ant-table-content,
          .items-table .ant-table-body {
            overflow: auto !important; /* ให้มีแถบเลื่อนแน่ ๆ */
            scrollbar-gutter: stable both-edges;
            scrollbar-width: thin; /* Firefox */
          }
          .items-table .ant-table-content::-webkit-scrollbar,
          .items-table .ant-table-body::-webkit-scrollbar {
            height: 10px; /* แถบแนวนอน */
            width: 10px; /* แถบแนวตั้ง */
          }
          .items-table .ant-table-content::-webkit-scrollbar-thumb,
          .items-table .ant-table-body::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.3);
            border-radius: 8px;
          }
          .ant-table-wrapper .ant-table-thead > tr > th {
            background: #d05c00 !important;
            color: #fff;
            font-weight: 600;
          }
          .ant-table-tbody > tr.row-even > td {
            background: #ffffff;
          }
          .ant-table-tbody > tr.row-odd > td {
            background: oklch(0.98 0.01 71.17);
          }
          .ant-table-tbody > tr:hover > td {
            background: oklch(0.91 0.05 60.5) !important;
          }
          .ant-table-tbody > tr.ant-table-row-selected > td {
            background: oklch(0.91 0.05 60.5) !important;
          }
          .tbl-footer {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 10px 8px;
            border: 1px solid #f0f0f0;
            border-top: none;
            border-radius: 0 0 8px 8px;
            background: #fff;
          }
          .tbl-footer .left {
            font-size: 12px;
            color: #555;
          }
          .tbl-footer .right {
            display: flex;
            align-items: center;
          }
          .tbl-body-rel {
            position: relative;
          }
          .tbl-body-rel2 {
            position: relative;
          }

          .tbody-loading {
            position: absolute;
            inset: 42px 0 0 0; /* ดันลงต่ำกว่าหัวตารางนิดหน่อย */
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(255, 255, 255, 0.6);
            pointer-events: none; /* ไม่บัง scroll */
          }

          .item-name-link:hover {
            text-decoration: underline;
          }

          .ant-table-tbody a.item-name-link {
            color: #050505ff;
            text-decoration: none !important;
            cursor: pointer;
          }

          .ant-table-tbody a.item-name-link:hover {
            text-decoration: underline !important;
          }
        `}</style>
      </>
    </>
  );
}

export default Main;
